import { CognitoConfiguration } from '@cognitoforms/utils/clientside-configuration';
import session from '@cognitoforms/api/services/session';
import type { JourneyStage } from '@cognitoforms/api/services/journey-context';

export const NO_EXPERIMENT_FLAGS = 'None';
export const MAX_EXPERIMENT_FLAGS_LENGTH = 512;
type Declarations = { [stage: string]: string[] };

/**
 * The flags observed on a stage that are on for this session, sorted and comma separated. `undefined` where
 * nothing could evaluate them — no session established yet, or a page served without the declarations — so
 * the dimension is omitted rather than reading as a control group.
 */
export function experimentFlags(stage: JourneyStage): string | undefined {
	const declarations = CognitoConfiguration.JourneyExperimentFlags;
	const info = session.value;

	if (!declarations || !info)
		return undefined;

	return resolveExperimentFlags(stage, declarations, info.enabledFeatures ?? {});
}

export function resolveExperimentFlags(stage: JourneyStage, declarations: Declarations, enabled: Partial<Record<string, boolean>>): string {
	const value = (declarations[stage] ?? [])
		.filter(flag => enabled[flag] === true)
		.sort()
		.join(',');

	return value ? value.slice(0, MAX_EXPERIMENT_FLAGS_LENGTH) : NO_EXPERIMENT_FLAGS;
}
